import { FC, ReactNode } from 'react';
import styles from './DropdownMortgagePayment.css';

interface IDropdownMortgagePaymentProps {
  mortgageTypeFilter: ReactNode;
  mortgagePaymentFilter: ReactNode;
}

export const DropdownMortgagePayment: FC<IDropdownMortgagePaymentProps> = ({
  mortgageTypeFilter,
  mortgagePaymentFilter,
}) => {
  return (
    <div className={styles['dropdown']} data-testid="DropdownMortgagePayment">
      <div className={styles['dropdown-filter']}>{mortgagePaymentFilter}</div>
      <div className={styles['dropdown-filter']} data-testid="DropdownMortgagePaymentType">
        {mortgageTypeFilter}
      </div>
    </div>
  );
};
